export interface AppConfig {
  VUE_APP_MOCK_API: boolean;
  VUE_APP_API_URL: string | undefined;
  VUE_APP_IDS: string | undefined;
  VUE_APP_SUPPORTED_LANGUAGES: string[];
  VUE_APP_SUPPORT_EMAIL: string;
  VUE_APP_API_GATEWAY_URL: string | undefined;
  VUE_APP_MEDIA_INTELLIGENCE_URL: string | undefined;
}

const defaultConfig: AppConfig = {
  VUE_APP_MOCK_API: false,
  VUE_APP_API_URL: undefined,
  VUE_APP_IDS: undefined,
  VUE_APP_SUPPORTED_LANGUAGES: ['en', 'de', 'nl', 'fr', 'es', 'it', 'pt', 'ro'],
  VUE_APP_SUPPORT_EMAIL: 'helpdesk@friss.freshservice.com',
  VUE_APP_API_GATEWAY_URL: undefined,
  VUE_APP_MEDIA_INTELLIGENCE_URL: undefined
};

export default defaultConfig;
